/*
 * TestCoinReveal — dev-only test harness for the reward ceremony components.
 *
 * Route: /test/coin-reveal — 404 in production (via NODE_ENV guard in App.jsx).
 *
 * Includes preset buttons to invoke different claim configurations, plus
 * an "isolated" view of the two onboarding bookend screens.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CoinReveal from "../components/rewards/CoinReveal";
import OnboardingWelcome from "../components/rewards/OnboardingWelcome";
import OnboardingComplete from "../components/rewards/OnboardingComplete";

const PRESETS = {
  welcome_2claim: {
    label: "Welcome — 10k + 2k email",
    claims: [
      { label: "WELCOME BONUS", amount: 10000 },
      { label: "EMAIL COIN CLAIMS", amount: 2000 },
    ],
  },
  welcome_only: {
    label: "Welcome only — 10k",
    claims: [{ label: "WELCOME BONUS", amount: 10000 }],
  },
  task_small: {
    label: "Task reward — 500",
    claims: [{ label: "NEWSLETTER REWARD", amount: 500 }],
  },
  referral_2k: {
    label: "Referral — 2000",
    claims: [{ label: "REFERRAL REWARD", amount: 2000 }],
  },
  stress_5: {
    label: "5-claim stress test",
    claims: [
      { label: "WELCOME BONUS", amount: 10000 },
      { label: "EMAIL CLAIMS", amount: 2000 },
      { label: "AFFILIATE BONUS", amount: 5000 },
      { label: "STREAK BONUS", amount: 300 },
      { label: "MYSTERY DROP", amount: 111 },
    ],
  },
};

const btnStyle = {
  padding: "10px 16px",
  borderRadius: 999,
  border: "1px solid rgba(212,175,106,.4)",
  background: "rgba(212,175,106,.1)",
  color: "#e9c98a",
  cursor: "pointer",
  fontFamily: "Marcellus, serif",
  letterSpacing: ".05em",
  fontSize: 13,
};
const btnStyleActive = { ...btnStyle, background: "rgba(212,175,106,.25)", color: "#f2e9d8" };

export default function TestCoinReveal() {
  const [mode, setMode] = useState("welcome_2claim");
  const [screen, setScreen] = useState("coin"); // "coin" | "welcome" | "complete"
  const [key, setKey] = useState(0);
  const navigate = useNavigate();
  const preset = PRESETS[mode];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "radial-gradient(ellipse at 50% -10%, #241a33 0%, #0a0812 55%, #060509 100%)",
        color: "#e9e2d8",
        fontFamily: "Inter, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "24px 16px 48px",
      }}
      data-testid="test-coin-reveal-page"
    >
      <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap", justifyContent: "center" }}>
        <button style={screen === "coin"     ? btnStyleActive : btnStyle} onClick={() => setScreen("coin")}     data-testid="test-mode-coin">Coin only</button>
        <button style={screen === "welcome"  ? btnStyleActive : btnStyle} onClick={() => setScreen("welcome")}  data-testid="test-mode-welcome">Welcome screen</button>
        <button style={screen === "complete" ? btnStyleActive : btnStyle} onClick={() => setScreen("complete")} data-testid="test-mode-complete">Complete screen (live API)</button>
      </div>

      {screen === "coin" && (
        <>
          <div style={{ display: "flex", gap: 6, marginBottom: 12, flexWrap: "wrap", justifyContent: "center", maxWidth: 800 }}>
            {Object.entries(PRESETS).map(([k, p]) => (
              <button
                key={k}
                style={mode === k ? btnStyleActive : btnStyle}
                onClick={() => { setMode(k); setKey((n) => n + 1); }}
                data-testid={`test-preset-${k}`}
              >
                {p.label}
              </button>
            ))}
            <button style={btnStyle} onClick={() => setKey((n) => n + 1)} data-testid="test-replay">
              🔁 Replay
            </button>
          </div>
          <div style={{ marginTop: 32 }}>
            <CoinReveal
              key={key}
              claims={preset.claims}
              totalLabel="TOTAL"
              claimLabel="CLAIM &amp; CONTINUE"
              claimSubtext="This is a test scenario"
              onClaim={() => alert("Claim clicked — would navigate now")}
              replayable
              soundEnabled
              autoStart
              showBreakdown
            />
          </div>
        </>
      )}

      {screen === "welcome" && (
        <OnboardingWelcome
          userName="Laz"
          totalSteps={8}
          onBegin={() => alert("Would proceed to Section 1")}
        />
      )}

      {screen === "complete" && (
        <OnboardingComplete
          userName="Laz"
          partnerName="Jordan"
          onClaim={() => navigate("/dashboard")}
        />
      )}
    </div>
  );
}
